import DialogField from 'components/DialogField/DialogField'

export default DialogField
export { getValue } from 'components/DialogField/DialogField'
